import useMap from "../utils/useMap";

const keyToSymBol = (() => {
    const tblKeyAsSymBol = useMap();

    return (key) => {
        if (typeof key === 'symbol') {
            return key
        }
        if (!tblKeyAsSymBol.has(key)) {
            tblKeyAsSymBol.set(key, Symbol(key));
        }
        return tblKeyAsSymBol.get(key);
    }
})();

const useWarehouse = (() => {
    const warehouse = useMap();
    /**@type {Map.<string,Function} */
    const provideDataCallbacks = useMap();

    window['zoneWarehouse'] = warehouse

    const setData = (key, data) => {
        const skey = keyToSymBol(key);
        warehouse.set(skey, data);
    }

    const removeData = (key) => {
        const skey = keyToSymBol(key);
        warehouse.delete(skey);
    }

    const callProvideData = (key) => {
        if (!provideDataCallbacks.has(key)) {
            return
        }
        const data = provideDataCallbacks.get(key).call(null);
        setData(key, data);
    }

    const getData = (key) => {
        const skey = keyToSymBol(key);
        const data = warehouse.get(skey);
        if (!data) {
            callProvideData(key);
        }
        return warehouse.get(skey);
    }

    const provideDataWhenEmpty = (key, fn) => {
        if (typeof fn !== 'function') {
            return;
        }
        provideDataCallbacks.set(key, fn);
    }

    return () => ({
        setData,
        getData,
        removeData,
        provideDataWhenEmpty
    })

})();



export default useWarehouse;